import { IMessage } from '../interfaces/component-interfaces';

export const shouldShowAdditionalDetails = (messages: IMessage[], index: number): boolean => {
  if (index < 0 || index >= messages.length) return false;

  const current = messages[index];
  const next = messages[index + 1];

  if (current.type === 'Typing' && index === messages.length - 1) {
    return true;
  }

  const showableTypes = ['chatbot', 'agent', 'user'];
  if (!showableTypes.includes(current.type)) {
    return false;
  }

  if (next) {
    const isSameSender = next.type === current.type && next.senderDisplayName === current.senderDisplayName;

    if (isSameSender) {
      const currentTime = new Date(current.timestamp).getTime();
      const nextTime = new Date(next.timestamp).getTime();
      const diffInMinutes = Math.abs(nextTime - currentTime) / (1000 * 60);

      // If same sender but more than 1 min apart, show avatar
      if (diffInMinutes > 1) {
        return true;
      }

      // Otherwise, skip avatar
      return false;
    }
  }

  return true;
};

export const getConversationEventMessage = (action: 'add' | 'remove', agentName: string): string => {
  if (action === 'add') {
    return `${agentName} joined.`;
  }
  return `${agentName} left.`;
};
